export function joinUrl(base: string, ...parts: string[]) {
  let full = base

  for (const part of parts) {
    const endSlash = full.endsWith("/")
    const startSlash = part.startsWith("/")

    if (endSlash && startSlash) {
      full += part.slice(1)
    } else if (endSlash || startSlash) {
      full += part
    } else {
      full += `/${part}`
    }
  }

  return full
}
